import React, { Component } from "react"
import { connect } from "react-redux"
import {
  Dialog,
  Card,
  CardContent,
  Button,
  TextField,
  Typography,
} from "@material-ui/core"
import LoadingButton from "../LoadingButton/index.jsx"
import PhoneInput from "../PhoneInput"
import { openSnackBar } from "../../actions/snack-bar"
import { getUserByPhone, updateUser } from "../../actions/users.js"
import { login, register } from "../../actions/authentication.js"

const defaultState = {
  phone: "",
  pass: "",
  working: false,
  phoneValidity: { phone: false, valid: false },
  hasAccount: false,
  showPassword: false,
  userData: {},
  first_name: "",
  last_name: "",
}

class HiddenLoginModal extends Component {
  state = defaultState

  promise = {
    resolve: e => {
      this.setState(defaultState)
      this.props.promise.resolve(e)
    },
    reject: e => {
      this.setState(defaultState)
      this.props.promise.reject(e)
    },
  }

  cancel = () => {
    if (this.state.showPassword) {
      const phone = this.state.phone
      this.setState(defaultState)
      this.setState({ phone })
    } else {
      this.setState(defaultState)
      this.promise.reject({ status: "canceled" })
    }
  }

  render() {
    const {
      phone,
      pass,
      working,
      phoneValidity,
      hasAccount,
      showPassword,
      userData,
      first_name,
      last_name,
    } = this.state
    const { open } = this.props
    const promise = this.promise
    return (
      <Dialog open={open}>
        <Card>
          <CardContent style={{ minWidth: "300px" }}>
            {showPassword ? (
              <React.Fragment>
                <Typography>
                  {hasAccount ? "Enter Password" : "Create Password"}
                </Typography>
                <TextField
                  label="Password"
                  onChange={e => this.setState({ pass: e.target.value })}
                  value={pass}
                  fullWidth
                  type="password"
                />
                <br />
                {(userData &&
                  (!userData.first_name || userData.first_name.length === 0)) ||
                (!userData.last_name || userData.last_name.length === 0) ||
                !userData ? (
                  <div>
                    <TextField
                      label="First Name"
                      onChange={e =>
                        this.setState({ first_name: e.target.value })
                      }
                      value={first_name}
                      fullWidth
                    />
                    <TextField
                      label="Last Name"
                      onChange={e =>
                        this.setState({ last_name: e.target.value })
                      }
                      value={last_name}
                      fullWidth
                    />
                  </div>
                ) : null}
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Typography>Enter Your Mobile Number</Typography>
                <PhoneInput
                  name="loginPhone"
                  id="loginPhone"
                  value={phone}
                  onChange={phone => this.setState({ phone })}
                  setValidity={e =>
                    this.setState({
                      phoneValidity: { phone: e.phone, valid: e.valid },
                    })
                  }
                />
              </React.Fragment>
            )}
          </CardContent>
          <CardContent>
            <div style={{ display: "flex" }}>
              <Button color="secondary" onClick={this.cancel}>
                {showPassword ? "Back" : "Cancel"}
              </Button>
              <div style={{ flexGrow: "1" }} />
              <LoadingButton
                color="primary"
                working={working}
                buttonclicked={() => {
                  if (!showPassword) {
                    if (phoneValidity.phone && phoneValidity.valid) {
                      this.setState({ working: true })
                      this.props
                        .dispatch(getUserByPhone(phone))
                        .then(user => {
                          if (user && user.id) {
                            this.setState({
                              hasAccount: true,
                              showPassword: true,
                              working: false,
                              userData: user,
                              first_name: user.first_name
                                ? user.first_name
                                : "",
                              last_name: user.last_name ? user.last_name : "",
                            })
                          } else {
                            throw new Error("no user")
                          }
                        })
                        .catch(err => {
                          this.setState({
                            hasAccount: false,
                            showPassword: true,
                            working: false,
                          })
                        })
                    } else {
                      this.props.dispatch(
                        openSnackBar({ message: "Invalid Phone Number" })
                      )
                    }
                  } else {
                    if (first_name.length > 0 && last_name.length > 0) {
                      this.setState({ working: true })
                      if (hasAccount) {
                        this.props
                          .dispatch(login({ phone, password: pass }))
                          .then(user => {
                            if (
                              user.first_name !== first_name ||
                              user.last_name !== last_name
                            ) {
                              this.props.dispatch(
                                updateUser(user.id, { first_name, last_name })
                              )
                            }
                            this.setState({ working: false })
                            promise.resolve({ status: "logged in" })
                          })
                          .catch(() => {
                            this.setState({ working: false })
                          })
                      } else {
                        this.props
                          .dispatch(
                            register({
                              phone,
                              password: pass,
                              first_name,
                              last_name,
                            })
                          )
                          .then(() => {
                            this.setState({ working: false })
                            promise.resolve({ status: "logged in" })
                          })
                          .catch(() => {
                            this.setState({ working: false })
                          })
                      }
                    } else {
                      this.props.dispatch(
                        openSnackBar({
                          message: "Invalid first and/or last name",
                        })
                      )
                    }
                  }
                }}
              >
                Submit
              </LoadingButton>
            </div>
          </CardContent>
        </Card>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  return {
    open: state.hiddenLoginModal.open,
    promise: state.hiddenLoginModal.promise,
  }
}

const connector = connect(mapStateToProps)

export default connector(HiddenLoginModal)
